<template>

    <div class="flex flex-col dark:text-white mb-5">
        <div class="mb-6">
            <div class="flex items-center justify-between">
                <div>
                    <h2 class="text-2xl font-bold text-gray-900 dark:text-white">
                        Detalhes do Membro - {{ userData?.name || userData?.email || 'Carregando...' }}
                    </h2>
                    <p class="text-gray-600 dark:text-gray-400">
                        Configure permissões e visualize histórico de convites
                    </p>
                </div>
                <button
                    @click="$router.go(-1)"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700"
                >
                    ← Voltar
                </button>
            </div>
        </div>

        <div class="space-y-6">
            <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                    Configurações do Portal Manual Access Control
                </h3>

                <form @submit.prevent="updatePortalConfig" class="space-y-4">
                    <div class="grid grid-cols-2 gap-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-md">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Nome
                            </label>
                            <p class="text-sm text-gray-900 dark:text-white">{{ userData?.name || '-' }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Email
                            </label>
                            <p class="text-sm text-gray-900 dark:text-white">{{ userData?.email || '-' }}</p>
                        </div>
                    </div>

                    <div>
                        <label class="inline-flex cursor-pointer items-center">
                            <input
                                v-model="configForm.is_enabled"
                                type="checkbox"
                                class="sr-only"
                            />
                            <div
                                :class="{
                                    'bg-indigo-500': configForm.is_enabled,
                                    'bg-gray-400': !configForm.is_enabled,
                                }"
                                class="relative flex h-6 w-10 items-center rounded-full transition duration-200 ease-in-out"
                            >
                                <span
                                    :class="{
                                        'translate-x-4': configForm.is_enabled,
                                        'translate-x-0': !configForm.is_enabled,
                                    }"
                                    class="mx-0.5 my-auto inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out"
                                ></span>
                            </div>
                            <span class="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                                {{ configForm.is_enabled ? 'Habilitado' : 'Desabilitado' }}
                            </span>
                        </label>
                        <div class="mt-1">
                            <small class="text-gray-500 dark:text-gray-400">
                                Habilitar ou desabilitar o convite manual
                            </small>
                        </div>
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Vendas Mínimas Requeridas
                        </label>
                        <small class="text-gray-500 dark:text-gray-400">
                            Quantas vendas o usuário precisa fazer para poder realizar invites manualmente (o valor abaixo + 1 venda)
                        </small>
                        <input
                            v-model.number="configForm.min_sales_required"
                            type="number"
                            min="0"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            placeholder="10"
                        />
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Período de Vendas (dias)
                        </label>
                        <small class="text-gray-500 dark:text-gray-400">
                            Período de tempo para contar as vendas
                        </small>
                        <input
                            v-model.number="configForm.sales_period_days"
                            type="number"
                            min="1"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            placeholder="360"
                        />
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Vendas por Acesso Manual
                        </label>
                        <small class="text-gray-500 dark:text-gray-400">
                            Quantas vendas o usuário precisa fazer para poder realizar invites manualmente
                        </small>
                        <input
                            v-model.number="configForm.sales_per_manual_access"
                            type="number"
                            min="1"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            placeholder="1"
                        />
                    </div>

                    <div class="flex justify-end space-x-3 pt-4">
                        <button
                            type="submit"
                            :disabled="configLoading"
                            class="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 disabled:opacity-50"
                        >
                            {{ configLoading ? 'Salvando...' : 'Salvar Configurações' }}
                        </button>
                    </div>
                </form>
            </div>

            <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
                <div class="flex items-center justify-between mb-4">
                    <h3 class="text-lg font-medium text-gray-900 dark:text-white">
                        Validação de Acesso Manual
                    </h3>
                    <button
                        @click="fetchValidation"
                        :disabled="validationLoading"
                        class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md disabled:opacity-50"
                    >
                        <span v-if="validationLoading">Carregando...</span>
                        <span v-else>Atualizar</span>
                    </button>
                </div>

                <div v-if="validationLoading" class="space-y-4">
                    <div v-for="n in 3" :key="n" class="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                </div>

                <div v-else-if="validation" class="space-y-4">
                    <div class="p-4 rounded-lg border" :class="validation.allow_manual_access ? 'bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800' : 'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800'">
                        <div class="flex items-center space-x-2">
                            <div class="w-3 h-3 rounded-full" :class="validation.allow_manual_access ? 'bg-green-500' : 'bg-red-500'"></div>
                            <span class="font-medium" :class="validation.allow_manual_access ? 'text-green-800 dark:text-green-200' : 'text-red-800 dark:text-red-200'">
                                {{ validation.allow_manual_access ? 'Invite Manual Permitido' : 'Invite Manual Negado' }}
                            </span>
                        </div>
                        <p class="mt-2 text-sm" :class="validation.allow_manual_access ? 'text-green-700 dark:text-green-300' : 'text-red-700 dark:text-red-300'">
                            {{ validation.reason }}
                        </p>
                    </div>

                    <div v-if="validation.sales_count !== undefined" class="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Vendas no Período</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.sales_count || 0 }}</div>
                        </div>

                        <div v-if="validation.min_required !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Mínimo Exigido</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.min_required }}</div>
                        </div>

                        <div v-if="validation.manual_accesses_count !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Acessos Utilizados</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.manual_accesses_count }}</div>
                        </div>

                        <div v-if="validation.allowed_manual_accesses !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Acessos Permitidos</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.allowed_manual_accesses }}</div>
                        </div>

                        <div v-if="validation.remaining_accesses !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Acessos Restantes</div>
                            <div class="text-lg font-semibold text-green-600 dark:text-green-400">{{ validation.remaining_accesses }}</div>
                        </div>

                        <div v-if="validation.sales_per_manual_access !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Vendas por Acesso</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.sales_per_manual_access }}</div>
                        </div>

                        <div v-if="validation.period_days !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Período (dias)</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.period_days }}</div>
                        </div>
                    </div>
                </div>

                <div v-else class="text-center text-gray-500 dark:text-gray-400 py-8">
                    Nenhuma informação de validação disponível
                </div>
            </div>

            <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
                <div class="flex items-center justify-between mb-4">
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                        Pessoas Convidadas pelo Produtor
                    </h3>
                </div>

                <div class="overflow-x-auto">
                    <table class="w-full table-auto border-collapse text-sm">
                        <thead>
                            <tr class="bg-gray-50 dark:bg-gray-700">
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">ID</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Portal</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Usuário</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Email</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Tipo</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Dias de Acesso</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Expira em</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Criado em</th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                            <template v-if="invitesLoading">
                                <tr v-for="n in 5" :key="'loading-' + n">
                                    <td v-for="col in 8" :key="'col-' + col" class="px-3 py-2">
                                        <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else-if="invites.length === 0">
                                <td colspan="8" class="px-3 py-8 text-center text-gray-500 dark:text-gray-400">
                                    Nenhum convite encontrado
                                </td>
                            </tr>
                            <tr v-else v-for="invite in invites" :key="invite.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">{{ invite.id || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">{{ invite.portal?.name || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">{{ invite.user?.name || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">{{ invite.user?.email || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">
                                    <span class="px-2 py-1 text-xs rounded-full" :class="getTypeClass(invite.type)">
                                        {{ getTypeLabel(invite.type) }}
                                    </span>
                                </td>
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">{{ invite.days_of_access || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">{{ formatDate(invite.expires_at) || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">{{ formatDate(invite.created_at) || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
import Pagination from "../../components/layouts/Pagination.vue";

export default {
    components: { Pagination },
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            configLoading: false,
            invitesLoading: false,
            validationLoading: false,
            memberData: {},
            userData: null,
            validation: null,
            configForm: {
                min_sales_required: 0,
                sales_period_days: 0,
                sales_per_manual_access: 0,
                is_enabled: false
            },
            invites: [],
        };
    },

    mounted() {
        this.fetchUserSetting();
        this.fetchValidation();
        this.fetchInvites();
    },

    methods: {
        async fetchUserSetting() {
            try {
                const { data } = await axios.get(`/api/auditoria/invite-members/${this.$route.params.user}`);

                this.userData = data.user;

                this.configForm = {
                    min_sales_required: data.min_sales_required || 0,
                    sales_period_days: data.sales_period_days || 0,
                    sales_per_manual_access: data.sales_per_manual_access || 0,
                    is_enabled: data.is_enabled === 1
                };

                console.log('Dados recebidos:', data);
                console.log('ConfigForm:', this.configForm);

            } catch (error) {
                console.error('Erro ao carregar dados:', error);
                this.toast.error('Erro ao carregar dados');
            }
        },

        async fetchInvites() {
            this.invitesLoading = true;

            try {
                const { data } = await axios.get(`/api/auditoria/invite-members/${this.$route.params.user}/invites`);
                this.invites = data;

            } catch (error) {
                this.toast.error('Erro ao carregar convites');
            } finally {
                this.invitesLoading = false;
            }
        },

        async updatePortalConfig() {
            this.configLoading = true;

            try {
                const { data } = await axios.put(`/api/auditoria/invite-members/${this.$route.params.user}`, this.configForm);
                this.toast.success(data.message || 'Configurações do portal atualizadas com sucesso!');
                this.fetchUserSetting();
            } catch (error) {
                this.toast.error(error.response?.data?.message || 'Erro ao atualizar configurações do portal');
                console.error('Erro ao atualizar configurações:', error);
            } finally {
                this.configLoading = false;
            }
        },

        async fetchValidation() {
            this.validationLoading = true;

            try {
                const { data } = await axios.get(`/api/auditoria/invite-members/${this.$route.params.user}/validation`);
                this.validation = data;
                console.log('Validation data:', data);
            } catch (error) {
                this.toast.error('Erro ao carregar validação');
                console.error('Erro ao buscar validação:', error);
            } finally {
                this.validationLoading = false;
            }
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            return new Date(dateString).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        getTypeLabel(type) {
            const types = {
                'common': 'Comum',
                'lifetime': 'Vitalício',
                'trial': 'Trial',
                'premium': 'Premium'
            };
            return types[type] || type || '-';
        },

        getTypeClass(type) {
            const classes = {
                'common': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
                'lifetime': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
                'trial': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
                'premium': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
            };
            return classes[type] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200';
        },
    },
};
</script>
